<agpr-take-over-panel
    [id]="'manageContentLibraryDialog'"
    header="Common.contentLibrary.manageDialog.heading"
    class="agpr-content-library-dialog"
    [responsiveWidth]="true"
    [minPanelWidth]="950"
    [maxPanelWidth]="1500"
    [animationTrigger]="animationTrigger"
    [hideSlideOverlay]="hideSlideOverlay"
    [overlayContainer]="overlayContainer"
    (visibleChange)="cancel()"
    (progressBarMouseEnter)="onIconHover($event)"
    [showProgressBar]="true"
    [focusCloseButton]="true"
    [used]="usedStorageBytes"
    [total]="totalStorageBytes"
>
    <div
        id="manageContentLibraryDialog_content"
        class="agpr-content-library-dialog-content"
        [class.no-content]="displayMediaItems.length === 0"
        [agprLoading]="fileUploading"
    >
        <div
            id="manageContentLibraryDialog_folders"
            class="agpr-column-content agpr-column-content--lhp"
        >
            <ul
                id="manageContentLibraryDialog_folders_defaultList"
                class="agpr-column-content-folders-list agpr-column-content-folders-list--noButtons"
            >
                <li
                    id="manageContentLibraryDialog_folders_allContent"
                    class="agpr-column-content-folders-item"
                    [class]="{
                        'agpr-column-content-folders-item--selected': selectedFolder === allContentFolder
                    }"
                    [agprTooltip]="allContentFolder.name"
                    (keydown)="selectFolder(allContentFolder)"
                    (click)="selectFolder(allContentFolder)"
                >
                    <span
                        id="manageContentLibraryDialog_folders_allContent_highlightBar"
                        class="agpr-column-content-folders-item-highlightBar"
                    ></span>
                    <div
                        id="manageContentLibraryDialog_folders_allContent_wrapper"
                        class="agpr-column-content-folders-itemWrapper"
                    >
                        <span
                            id="manageContentLibraryDialog_folders_allContent_icon"
                            class="fa-solid fa-folders agpr-column-content-folders-item-icon"
                        ></span>
                        <div
                            id="manageContentLibraryDialog_folders_allContent_label"
                            class="agpr-column-content-folders-item-label"
                        >
                            <span
                                id="manageContentLibraryDialog_folders_allContent_name"
                                class="agpr-column-content-folders-item-label-name"
                            >{{'Common.contentLibrary.folders.AllContent' | localize}}</span>
                            <span
                                id="manageContentLibraryDialog_folders_allContent_count"
                                class="agpr-column-content-folders-item-label-count"
                            >{{ allContentFolder.count }}</span>
                        </div>
                    </div>
                </li>
                <li
                    id="manageContentLibraryDialog_folders_uncategorized"
                    class="agpr-column-content-folders-item"
                    [class]="{
                        'agpr-column-content-folders-item--selected': selectedFolder === uncategorizedFolder
                    }"
                    [agprTooltip]="uncategorizedFolder.name"
                    (keydown)="selectFolder(uncategorizedFolder)"
                    (click)="selectFolder(uncategorizedFolder)"
                >
                    <span
                        id="manageContentLibraryDialog_folders_uncategorized_highlightBar"
                        class="agpr-column-content-folders-item-highlightBar"
                    ></span>
                    <div
                        id="manageContentLibraryDialog_folders_uncategorized_wrapper"
                        class="agpr-column-content-folders-itemWrapper"
                    >
                        <span
                            id="manageContentLibraryDialog_folders_uncategorized_icon"
                            class="fa-solid fa-folder-xmark agpr-column-content-folders-item-icon"
                        ></span>
                        <div
                            id="manageContentLibraryDialog_folders_uncategorized_label"
                            class="agpr-column-content-folders-item-label"
                        >
                            <span
                                id="manageContentLibraryDialog_folders_uncategorized_name"
                                class="agpr-column-content-folders-item-label-name"
                            >{{'Common.contentLibrary.folders.uncategorized' | localize}}</span>
                            <span
                                id="manageContentLibraryDialog_folders_uncategorized_count"
                                class="agpr-column-content-folders-item-label-count"
                            >{{ uncategorizedFolder.count }}</span>
                        </div>
                    </div>
                </li>
            </ul>
            <div
                id="manageContentLibraryDialog_folders_header"
                class="agpr-column-content-folders-header"
            >
                <span id="manageContentLibraryDialog_folders_header_label">{{ 'Common.contentLibrary.folder.header' | localize }}</span>
                <agpr-button
                    [id]="'manageContentLibraryDialog_folders_addFolder'"
                    [style]="buttonTypes.icon"
                    icon="fa-regular fa-duotone fa-square-plus"
                    tooltip="Common.contentLibrary.manageDialog.create"
                    (click)="addFolder()"
                ></agpr-button>
            </div>
            <div
                id="manageContentLibraryDialog_folders_separator"
                class="agpr-column-content-folders-separator"
            ></div>
            @if (foldersList.length === 0) {
                <agpr-message
                    [id]="'manageContentLibraryDialog_folders_noFolders'"
                    class="agpr-column-content-folders-noContent"
                    [severity]="messageSeverityEnum.noContent"
                    icon="fa-regular fa-duotone fa-file-slash"
                    >
                    {{ 'Common.contentLibrary.folder.noFolder' | localize }}
                </agpr-message>
            } @else {
                <agpr-scroll-panel
                    [id]="'manageContentLibraryDialog_folders_scrollPanel'"
                    class="agpr-column-content-folders-scrollpanel"
                >
                    <ul
                        id="manageContentLibraryDialog_folders_list"
                        class="agpr-column-content-folders-list"
                        agprListKeyboardNavigation
                        [list]="foldersList"
                    >
                        @for (folder of foldersList; track folder; let i = $index) {
                            <li
                                #newFolder
                                [id]="'manageContentLibraryDialog_folders_item_' + i"
                                class="agpr-column-content-folders-item"
                                [class]="{
                                    'agpr-column-content-folders-item--selected': selectedFolder?.id === folder.id
                                }"
                                [agprTooltip]="folder.name"
                                tooltipPosition="top"
                                (keydown.enter)="selectFolder(folder)"
                                (click)="selectFolder(folder)"
                            >
                                <span
                                    [id]="'manageContentLibraryDialog_folders_item_' + i + '_highlightBar'"
                                    class="agpr-column-content-folders-item-highlightBar"
                                ></span>
                                <div
                                    [id]="'manageContentLibraryDialog_folders_item_' + i + '_wrapper'"
                                    class="agpr-column-content-folders-itemWrapper"
                                >
                                    <span
                                        [id]="'manageContentLibraryDialog_folders_item_' + i + '_icon'"
                                        class="fa-solid fa-folder agpr-column-content-folders-item-icon"
                                    ></span>
                                    @if (folder.id === editingFolderId) {
                                        <div
                                            [id]="'manageContentLibraryDialog_folders_item_' + i + '_label'"
                                            class="agpr-column-content-folders-item-label"
                                            (clickOutside)="saveFolder(folder)"
                                        >
                                            <agpr-text-input
                                                [id]="'manageContentLibraryDialog_folders_item_' + i + '_nameInput'"
                                                class="agpr-column-content-folders-item-label-input"
                                                [(ngModel)]="editedFolderName"
                                                [maxLength]="255"
                                                [initialFocus]="true"
                                                [bottomMargin]="false"
                                                [selectOnEdit]="true"
                                                ariaLabel="Folder Name"
                                                (keyup.enter)="saveFolder(folder)"
                                                (blur)="saveFolder(folder)"
                                            ></agpr-text-input>
                                        </div>
                                    } @else {
                                        <div
                                            [id]="'manageContentLibraryDialog_folders_item_' + i + '_label'"
                                            class="agpr-column-content-folders-item-label"
                                        >
                                            <span
                                                [id]="'manageContentLibraryDialog_folders_item_' + i + '_name'"
                                                class="agpr-column-content-folders-item-label-name"
                                            >{{ folder?.name }}</span>
                                            <span
                                                [id]="'manageContentLibraryDialog_folders_item_' + i + '_count'"
                                                class="agpr-column-content-folders-item-label-count"
                                            >{{ folder?.count }}</span>
                                        </div>
                                    }
                                    <div
                                        [id]="'manageContentLibraryDialog_folders_item_' + i + '_actions'"
                                        class="agpr-column-content-folders-item-actions"
                                    >
                                        <agpr-button
                                            [id]="'manageContentLibraryDialog_folders_item_' + i + '_edit'"
                                            [style]="buttonTypes.icon"
                                            icon="fa-regular fa-duotone fa-pen"
                                            tooltip="Common.contentLibrary.manageDialog.edit"
                                            tooltipPosition="top"
                                            (click)="editFolder(folder)"
                                        ></agpr-button>
                                        <agpr-button
                                            [id]="'manageContentLibraryDialog_folders_item_' + i + '_delete'"
                                            [style]="buttonTypes.icon"
                                            icon="fa-regular fa-duotone fa-trash-can"
                                            tooltip="Common.contentLibrary.manageDialog.delete"
                                            tooltipPosition="top"
                                            (click)="deleteFolder(folder)"
                                        ></agpr-button>
                                    </div>
                                </div>
                            </li>
                        }
                    </ul>
                </agpr-scroll-panel>
            }
        </div>

        <ng-template #toolbar>
            <span
                id="manageContentLibraryDialog_toolbar_controls"
                class="agpr-column-center-toolbar-dropdown"
            >
                <agpr-filter-dropdown
                    [id]="'manageContentLibraryDialog_toolbar_filters'"
                    class="agpr-column-center-toolbar-filter"
                    [showQuickFilter]="true"
                    quickFilterPlaceholder="Common.contentLibrary.manageDialog.filterKeywords"
                ></agpr-filter-dropdown>
                <agpr-sort-order
                    [id]="'manageContentLibraryDialog_toolbar'"
                    class="agpr-column-center-toolbar-sort"
                    optionKey="enumValue"
                    optionLabel="displayString"
                ></agpr-sort-order>
                <input
                    #fileInput
                    id="manageContentLibraryDialog_toolbar_fileInput"
                    type="file"
                    style="display: none"
                    accept=".txt,.xls,.xlsx,.docx,.csv,.doc,.ppt,.pptx,.rtf,.png,.jpg,.jpeg,.gif,.odp,.ods,.odt,.pdf,.mp3,image/*"
                    (change)="onFileSelected($event)"
                />
                <agpr-button
                    [id]="'manageContentLibraryDialog_toolbar_upload'"
                    class="agpr-column-center-toolbar-upload"
                    label="Common.contentLibrary.empty.state.upload"
                    [style]="buttonTypes.tertiary"
                    (click)="onUploadClick()"
                ></agpr-button>
            </span>
            <span
                id="manageContentLibraryDialog_toolbar_chips"
                class="agpr-column-center-toolbar-chips"
            >
                <agpr-filter-chips
                    [id]="'manageContentLibraryDialog_toolbar_filterChips'"
                    [noContainerWhenEmpty]="noContainerWhenEmpty"
                    [emptyMessage]="''"
                ></agpr-filter-chips>
            </span>
        </ng-template>

        @if (displayMediaItems.length === 0 && !noContainerWhenEmpty) {
            <div
                id="manageContentLibraryDialog_emptyState"
                class="agpr-library-noContent"
            >
                <div
                    id="manageContentLibraryDialog_toolbar"
                    class="agpr-library-toolbar"
                >
                    <ng-container *ngTemplateOutlet="toolbar"></ng-container>
                </div>
                <div
                    id="manageContentLibraryDialog_emptyState_content"
                    class="agpr-library-noContent"
                >
                    <div
                        id="manageContentLibraryDialog_emptyState_container"
                        class="agpr-library-noContent-container"
                    >
                        <img
                            id="manageContentLibraryDialog_emptyState_image"
                            class="agpr-library-noContent-image"
                            src="assets/images/content-library.svg"
                            alt="Empty State"
                        />
                        <span
                            id="manageContentLibraryDialog_emptyState_header"
                            class="agpr-library-noContent-header"
                        >
                            {{ (selectedFolder === allContentFolder ?
                                'Common.contentLibrary.empty.state' :
                                'Common.contentLibrary.empty.state.folder') | localize }}
                        </span>
                        <span
                            id="manageContentLibraryDialog_emptyState_subheader"
                            class="agpr-library-noContent-subheader"
                        >
                            {{ (selectedFolder === allContentFolder ?
                                'Common.contentLibrary.empty.state.description' :
                                'Common.contentLibrary.empty.state.folder.description') | localize }}
                        </span>
                        <agpr-button
                            [id]="'manageContentLibraryDialog_emptyState_upload'"
                            label="Common.contentLibrary.empty.state.upload"
                            [style]="buttonTypes.primary"
                            (click)="onUploadClick()"
                        ></agpr-button>
                    </div>
                </div>
            </div>
        }
        @else if (noContainerWhenEmpty && displayMediaItems.length === 0) {
            <div
                id="manageContentLibraryDialog_noResults"
                class="agpr-library-noContent"
            >
                <div
                    id="manageContentLibraryDialog_toolbar"
                    class="agpr-library-toolbar"
                >
                    <ng-container *ngTemplateOutlet="toolbar"></ng-container>
                </div>
                <agpr-message
                    [id]="'manageContentLibraryDialog_noResults_message'"
                    class="agpr-column-right-details-noContent"
                    [severity]="messageSeverityEnum.noContent"
                    icon="fa-regular fa-file-slash"
                >
                    {{ 'Common.contentLibrary.details.noContent.filters' | localize }}
                </agpr-message>
            </div>
        }
        @else {
            <div
                id="manageContentLibraryDialog_files"
                class="agpr-column-center"
                role="group"
            >
                <div
                    id="manageContentLibraryDialog_toolbar"
                    class="agpr-column-center-toolbar"
                >
                    <ng-container *ngTemplateOutlet="toolbar"></ng-container>
                </div>
                <cdk-virtual-scroll-viewport
                    [id]="'manageContentLibraryDialog_files_list'"
                    [itemSize]="86"
                    [minBufferPx]="86"
                    [maxBufferPx]="172"
                    class="virtual-scroll-viewport agpr-virtualScroll"
                >
                    <div
                        #newMediaItem
                        *cdkVirtualFor="let item of displayMediaItemsRows; let i = index"
                        [id]="'manageContentLibraryDialog_files_row_' + i"
                    >
                        <div
                            [id]="'manageContentLibraryDialog_files_row_' + i + '_container'"
                            class="virtual-scroll-container"
                        >
                            <agpr-content-library-item
                                [id]="'manageContentLibraryDialog_files_item_' + (i * 2)"
                                class="virtual-scroll-container-item"
                                [item]="displayMediaItems[i * 2]"
                                [itemDetails]="itemDetails"
                                [isCurrentlySelected]="selectedItemId === displayMediaItems[i * 2]?.id"
                                [isSelected]="displayMediaItems[i * 2]?.isSelected"
                                [singleSelect]="singleSelect"
                                (selectionChange)="onSelectionChange($event)"
                                (itemSelected)="onItemClicked($event)"
                            ></agpr-content-library-item>
                            @if (displayMediaItems[i * 2 + 1]) {
                                <agpr-content-library-item
                                    [id]="'manageContentLibraryDialog_files_item_' + (i * 2 + 1)"
                                    class="virtual-scroll-container-item"
                                    [item]="displayMediaItems[i * 2 + 1]"
                                    [isCurrentlySelected]="selectedItemId === displayMediaItems[i * 2 + 1]?.id"
                                    [isSelected]="displayMediaItems[i * 2 + 1]?.isSelected"
                                    [singleSelect]="singleSelect"
                                    (selectionChange)="onSelectionChange($event)"
                                    (itemSelected)="onItemClicked($event)"
                                ></agpr-content-library-item>
                            } @else {
                                <div
                                    [id]="'manageContentLibraryDialog_files_row_' + i + '_placeholder'"
                                    class="virtual-scroll-container-item"
                                ></div>
                            }
                        </div>
                    </div>
                </cdk-virtual-scroll-viewport>
            </div>
            <div
                id="manageContentLibraryDialog_rightColumn"
                class="agpr-column-right"
            >
                <agpr-right-sidebar
                    [id]="'manageContentLibraryDialog_rightSidebar'"
                    class="agpr-content-library-dialog-rightSidebar"
                    [showTabTitle]="false"
                    [selectedTabIndex]="selectedTabIndex"
                    (selectedTabIndexChange)="tabIndexChange($event)">
                    <agpr-tab
                        [id]="'manageContentLibraryDialog_detailsTab'"
                        icon="fa-regular fa-file-lines fa-duotone"
                        tooltip="Common.contentLibrary.details"
                    >
                        @if (!selectedItem) {
                            <agpr-message
                                [id]="'manageContentLibraryDialog_detailsTab_noContent'"
                                class="agpr-column-right-details-noContent"
                                [severity]="messageSeverityEnum.noContent"
                                icon="fa-regular fa-file-slash"
                            >
                                {{ 'Common.contentLibrary.details.noContent' | localize }}
                            </agpr-message>
                        } @else {
                            <agpr-library-item-details
                                #libraryItemDetails
                                class="agpr-column-right-details"
                                [selectedItem]="selectedItem"
                                [currentUser]="currentUser"
                                [userNotes]="userNotes"
                            ></agpr-library-item-details>
                        }
                        <ng-template #tabFooter>
                            <agpr-action-bar [id]="'manageContentLibraryDialog_detailsTab_actionBar'">
                                <ng-template #right>
                                    @if (libraryItemDetails) {
                                        <ng-container *ngTemplateOutlet="libraryItemDetails.actionButtons" />
                                    }
                                </ng-template>
                            </agpr-action-bar>
                        </ng-template>
                    </agpr-tab>
                    <agpr-tab
                        [id]="'manageContentLibraryDialog_selectedFilesTab'"
                        icon="fa-regular fa-list-check fa-duotone"
                        tooltip="Common.contentLibrary.selectedFiles"
                    >
                        @if (currentlySelectedItems.length === 0) {
                            <agpr-message
                                [id]="'manageContentLibraryDialog_selectedFilesTab_noContent'"
                                class="agpr-column-right-details-noContent"
                                [severity]="messageSeverityEnum.noContent"
                                icon="fa-regular fa-file-slash"
                            >
                                {{ 'Common.contentLibrary.details.noContent' | localize }}
                            </agpr-message>
                        } @else {
                            <agpr-multiple-item-selection
                                class="agpr-column-right-multipleItemSelection"
                                [currentlySelectedItems]="currentlySelectedItems"
                                (clearSelectionRequested)="onClearSelection()"
                                (itemRemoved)="onSelectionChange($event)"
                                (itemUnselected)="onClearSelection()"
                            ></agpr-multiple-item-selection>
                        }
                    </agpr-tab>
                </agpr-right-sidebar>
            </div>
            <ng-template #takeOverFooterLeft>
                <agpr-button
                    [id]="'manageContentLibraryDialog_footer_cancel'"
                    label="Common.contentLibrary.manageDialog.cancel"
                    (click)="cancel()"
                    [style]="buttonTypes.secondary"
                ></agpr-button>
            </ng-template>
            <ng-template #takeOverFooterRight>
                @if (currentlySelectedItems.length > 0) {
                    <agpr-split-button
                        [id]="'manageContentLibraryDialog_footer_actions'"
                        label="Common.contentLibrary.manageDialog.actions"
                        [options]="contentLibraryActions"
                        panelPositionY="top"
                    ></agpr-split-button>
                }
                @if (!navBarLaunch && (currentlySelectedItems.length > 0)) {
                    <agpr-button
                        [id]="'manageContentLibraryDialog_footer_select'"
                        label="Common.contentLibrary.manageDialog.select"
                        [style]="buttonTypes.primary"
                        (click)="onFileSelect()"
                    ></agpr-button>
                }
            </ng-template>
        }
    </div>
</agpr-take-over-panel>